import { connect } from 'react-redux';
import { resetCredentials } from '../../stores/credentials-store';
import { ExpenseCheckMachineView } from './ExpenseCheckMachineView';

const mapDispatchToProps = {
  resetCredentials,
};

const connector = connect(null, mapDispatchToProps);

export const ExpenseCheckDirector = connector(ExpenseCheckMachineView);
